module.exports = __webpack_public_path__ + "img/p05.efb0cfb1.png";